export class AreaCoswinModel {
    public commesse: any[] = []; 
    public site: string;
    public job: any;
    public app_on_phone: boolean;
    public type_user: any;
    public notes: string; 
    public cid:string;
    public phone:string;
}

export class OrderModel {
  id: string;
  project_name: string;
  active: boolean;
  cdc_type: string;
  project_description: string;
  cid:string;
}